module.exports = __webpack_public_path__ + "images/organization/unlimited-boards.af28e1bead627155b257.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/organization/unlimited-boards.png
// module id = 5qn2
// module chunks = 13